import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";

import CollectionOtherActions from "./CollectionOtherActions";
import ModuleOtherActions from "./ModuleOtherActions";
import AnthologyOtherActions from "./AnthologyOtherActions";

const useStyles = makeStyles(theme => ({
  button: {
    padding: 4,
    [theme.breakpoints.up("md")]: {
      padding: 10,
    },
  },
  ellipsis: {
    width: 12,
    textAlign: "center",
  },

  menu: {
    marginLeft: 15,
  },
}));

const OtherActionsMenu = React.memo(function OtherActionsMenu(props) {
  const { group, removeFromParent, clearSelected } = props;
  const classes = useStyles();

  //-- Manage Other Actions Menu
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOtherActionsClick = event => {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = event => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const handleKeyDown = event => {
    event.stopPropagation();
    if (event.key === "Enter") {
      event.preventDefault();

      setAnchorEl(event.currentTarget);
    }

    if (event.key === "Tab") {
      return;
    }
  };

  return (
    <Fragment>
      <IconButton
        className={classes.button}
        onClick={handleOtherActionsClick}
        onKeyDown={handleKeyDown}
      >
        <Grid item className={classes.ellipsis}>
          <FontAwesomeIcon icon={faEllipsisVertical} />
        </Grid>
      </IconButton>
      <Menu
        id={`other-actions-for-${group.name}-menu`}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        classes={{
          paper: classes.menu,
        }}
      >
        {group.mediaType === "module" ? (
          <ModuleOtherActions module={group} clearSelected={clearSelected} />
        ) : group.mediaType === "anthology" ? (
          <AnthologyOtherActions
            anthology={group}
            removeFromParent={removeFromParent}
          />
        ) : group.mediaType === "collection" ? (
          <CollectionOtherActions
            collection={group}
            removeFromParent={removeFromParent}
          />
        ) : null}
      </Menu>
    </Fragment>
  );
});

export default OtherActionsMenu;
